import executeApi from 'shared/executeApi';
import { fetchAuthSession } from 'aws-amplify/auth';

/** ログアウト実行 */
const logoutBackend = async () => {
  // 認証
  const session = await fetchAuthSession();
  const email = session.tokens?.idToken?.payload?.email;
  const sessionId = session.tokens?.idToken?.payload?.sessionId;
  const jwtToken = session.tokens?.idToken?.toString();
  // SmeFrontAPIのURLを取得
  const baseURL = process.env.REACT_APP_SME_FRONT_API_ROOT!;
  // ログアウトAPI PATH
  const path = "/auth/logout/execution";
  const request = {
    "mailAddress": email,
    "sessionId": sessionId
  };
  try {
    const response = await executeApi(baseURL, path, jwtToken, 0, request);
    if (!response || response.data.res_cd === "I0000") {
      return true;
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
};

export default logoutBackend;
